import { toast } from "sonner";
import { signOut } from "next-auth/react";

/**
 * Fetch wrapper that handles session expiry.
 * NextAuth uses HttpOnly cookies — the browser sends them automatically,
 * so we no longer need to attach a Bearer token manually.
 */
export async function fetchWithAuth(input: RequestInfo | URL, init?: RequestInit) {
  const res = await fetch(input, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers || {}),
    },
  });

  if (res.status === 401) {
    if (typeof window !== "undefined") {
      try {
        toast.error("登录已过期，请重新登录");
      } catch { /* ignore */ }
      await signOut({ redirect: true, callbackUrl: "/login" });
    }
    throw new Error("登录已过期，需要重新登录");
  }

  return res;
}
